<script>
export default {};
</script>
<template>
  <div class="b-form-item">
    <div class="b-form-item__slot">
      sadsa
    </div>
  </div>
</template>
<style lang="scss">
  .b-form-item {
    position: relative;
    padding: 16px 0;

    &__slot {
      height: 28px;
    }
  }
</style>
